import React from 'react';
import './RedeemAtlantica.css';
import Modal from '../Modal/Modal.js';
import ReactPortal from '../ReactPortal/ReactPortal';

const Redeem = ({ trigger, setTrigger, children }) => {
  return (
    <>
      {trigger ? (
        <ReactPortal wrapperId='react-portal-modal-container'>
          <Modal
            setTrigger={setTrigger}
            trigger={trigger}
            children={children}
          />
        </ReactPortal>
      ) : (
        ''
      )}
    </>
  );
};

export default Redeem;
